module.exports = function getResource (label, vars = []) {
    let resources = {
        signInAriaLabel: `Sign in to love ${vars[0]}`,
        unloveLabel: 'Unlove',
        loveLabel: 'Love'
    };
    return resources[label];
};
